import { StaticImage } from "gatsby-plugin-image"

import { ContentRating } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

import FAQs from "./faqs"
import PageHeader from "./page-header"
import Products from "./products"
import Steps from "./steps"

const TreatmentPlanNavigation = () => {
  const { t } = useTranslation()

  return (
    <div sx={{ maxWidth: "468px", mx: "auto" }}>
      <PageHeader />

      <Steps />

      <Products />

      <FAQs />

      <div
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <StaticImage
          src="../../../images/formel-skin-doctors.webp"
          alt=""
          sx={{
            display: [null, "none"],
            mx: -4,
          }}
        />
        <StaticImage
          src="../../../images/formel-skin-doctors_desktop.webp"
          alt=""
          sx={{
            display: ["none", "block"],
          }}
        />
        <ContentRating
          rating={4.8}
          description={t(
            "Start.InitialTreatmentPlan.YourDoctor.ratingDescription"
          )}
          sx={{
            position: "absolute",
            bottom: 24,
            py: 2,
            px: 4,
            maxWidth: "180px",
            textAlign: "center",
            backgroundColor: "background",
            borderRadius: "16px",
            color: "textDark",
            "& > div:first-of-type > span": {
              mb: 1,
            },
            "& > div:nth-of-type(2)": {
              mt: "2px",
            },
          }}
        />
      </div>
    </div>
  )
}

export default TreatmentPlanNavigation
